/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Button, Input } from 'components/atoms';
import { DateInputPicker } from 'components/atoms/DateInputPicker';
import { Modal } from 'components/molecules/Modal';
import { useGetUserProfile, useUpdateUserProfile } from 'framework/api/methods';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setUserDetails } from 'store/reducers/user/userSlice';

export interface ProfileProps {
  [x: string]: any;
}

export const Profile: FC<ProfileProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: '',
    brn: '',
    email: '',
    phone: '',
    address: '',
    currentPassword: '',
    newPassword: '',
    retryPassword: '',
  });

  const [isOpenLogoutConfirmationModal, setIsOpenLogoutConfirmationModal] = useState(false);

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const convertToLocalNumber = (phoneNumber: string) => {
    const str = String(phoneNumber);
    if (str.startsWith('94')) {
      return `0${str.slice(2)}`;
    }
    return `0${str}`;

    return str;
  };

  const onSuccessUserProfile = (data: any) => {
    const userdata = data?.enterpriseData[0];
    setFormData({
      ...formData,
      name: userdata.enterprise_name,
      brn: userdata.br_number,
      email: userdata.email,
      phone: userdata.phone,
      address: userdata.address,
    });
  };

  const onErrorUserProfile = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  /** Get all cards API */
  const { refetch: getUserProfile } = useGetUserProfile(onSuccessUserProfile, onErrorUserProfile);

  useEffect(() => {
    getUserProfile();
  }, []);

  const { mutate: updateUserProfileMutate, isLoading: updateUserProfileIsLoading } =
    useUpdateUserProfile();

  // function to request Otp for registered / unregistered users
  const updateUserProfile = () => {
    updateUserProfileMutate(
      {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'Password Updated successfully', 'success');
          setTimeout(() => {
            localStorage.clear();
            navigate('/auth/login', { replace: true });
          }, 1000);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-full md:p-8 p-2 overflow-y-auto">
      <div className="bg-[#ffffff] shadow-md px-10 py-4 flex flex-col md:w-2/3 w-full md:h-fit h-full rounded overflow-auto">
        <div className="flex w-full justify-center items-center h-fit text-[#F7941E] pb-5">
          Personal Information
        </div>

        <div className="flex w-full h-full gap-x-5 md:flex-row flex-col">
          <div className="md:w-1/2 flex flex-col w-full">
            <Input
              labelValue="Enterprise Name"
              inputClassName="!rounded"
              appearance="gray"
              value={formData.name}
              isDisabled
              onChange={(e) => {
                setFormData({
                  ...formData,
                  name: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Business Register Number"
              inputClassName="!rounded"
              className="mt-2"
              appearance="gray"
              isDisabled
              value={formData.brn}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  brn: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Phone"
              inputClassName="!rounded"
              appearance="gray"
              isDisabled
              value={convertToLocalNumber(formData.phone)}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  phone: e.target.value,
                });
              }}
            />
          </div>

          <div className="md:w-1/2 w-full flex flex-col gap-y-2">
            <Input
              labelValue="Address"
              inputClassName="!rounded"
              className="mt-2"
              isDisabled
              appearance="gray"
              value={formData.address}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  address: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Email"
              inputClassName="!rounded"
              appearance="gray"
              isDisabled
              value={formData.email}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  email: e.target.value,
                });
              }}
            />
          </div>
        </div>

        <div className="flex w-full justify-center items-center h-fit text-[#F7941E] pb-5">
          Change Password
        </div>
        <div className="flex w-full h-full gap-x-5 md:flex-row flex-col">
          <div className="md:w-1/2 w-full flex flex-col gap-y-2">
            <Input
              labelValue="Current password"
              inputClassName="!rounded"
              className="mt-2"
              appearance="gray"
              value={formData.currentPassword}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  currentPassword: e.target.value,
                });
              }}
            />
          </div>

          <div className="md:w-1/2 w-full flex flex-col gap-y-2">
            <Input
              labelValue="New Password"
              inputClassName="!rounded"
              className="mt-2"
              appearance="gray"
              value={formData.newPassword}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  newPassword: e.target.value,
                });
              }}
            />

            <Input
              labelValue="Re-enter New Password"
              inputClassName="!rounded"
              appearance="gray"
              value={formData.retryPassword}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  retryPassword: e.target.value,
                });
              }}
            />
          </div>
        </div>

        <div className="">
          <Button
            isRounded
            className="mt-5"
            disabled={
              !formData.currentPassword ||
              !formData.retryPassword ||
              !formData.newPassword ||
              !(formData.newPassword === formData.retryPassword)
            }
            isLoading={updateUserProfileIsLoading}
            onClick={() => {
              setIsOpenLogoutConfirmationModal(true);
            }}
          >
            Submit
          </Button>
        </div>
      </div>

      <Modal
        isActive={isOpenLogoutConfirmationModal}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="Yes"
        secondaryButtonTitle="No"
        secondaryButtonProps={{
          className: '!w-[100px]',
        }}
        primaryButtonProps={{
          className: '!w-[100px] !mr-2',
          isLoading: updateUserProfileIsLoading,
        }}
        onClickPrimaryBtn={() => {
          updateUserProfile();
        }}
        onClickSecondaryBtn={() => {
          setIsOpenLogoutConfirmationModal(false);
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#7B1B67]"
              onClick={() => {
                setIsOpenLogoutConfirmationModal(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#7B1B67]" />
            <div className="pt-1 text-base text-[#737791] pb-3 px-2 text-center">
              This will update your password and redirect you to the login page. Are you sure you
              want to update your password?
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Profile;
